import { Section, SectionTitle, PageHero, CTA } from "@/components/site/SiteBits";
import { Leaf, Gauge, Route, TrendingDown, Fuel, Recycle } from "lucide-react";

const M = [
  { icon: Fuel, title: "Fuel Consumption", desc: "Litres tracked per vehicle, route and shipment." },
  { icon: Gauge, title: "Vehicle Emissions", desc: "CO₂ output monitored by fleet and corridor." },
  { icon: Route, title: "Route Efficiency", desc: "Optimised routing to cut distance and idle time." },
  { icon: TrendingDown, title: "Empty Kilometres", desc: "Reduce deadhead miles through better planning." },
  { icon: Recycle, title: "Load Utilisation", desc: "Maximise capacity per trip to lower per-unit carbon." },
  { icon: Leaf, title: "Carbon per Shipment", desc: "Emissions per shipment and per kilometre reported." },
];

export default function Sustainability() {
  return (
    <div>
      <PageHero eyebrow="Sustainability" title="Greener freight, measured honestly"
        subtitle="Ebik builds sustainability reporting into the platform — with a carbon reporting dashboard for corporate customers tracking emissions, efficiency and utilisation."
        image="/services/specialized-cargo.jpg" />
      <Section>
        <SectionTitle center eyebrow="What We Track" title="Carbon and efficiency metrics" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {M.map((m) => (
            <div key={m.title} className="rounded-xl border border-border bg-card p-6 card-hover">
              <div className="w-12 h-12 rounded-xl bg-emerald-100 text-emerald-600 dark:bg-emerald-500/15 flex items-center justify-center"><m.icon size={24} /></div>
              <h3 className="mt-4 font-heading font-bold">{m.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{m.desc}</p>
            </div>
          ))}
        </div>
      </Section>
      <CTA />
    </div>
  );
}
